module.exports = __webpack_public_path__ + "assets/6327ff8d569aa463a91e5ea774d1980e.js";